module.exports = __webpack_public_path__ + "img/cal.33e1dbb1.png";